import React from "react";

import "./LoadingScreen.scss";
import { ReactComponent as ReactLogo } from "../header/logo.svg";
import { Trans, withTranslation } from "react-i18next";

const LoadingScreen = () => {
  return (
    <div id={"loading-screen"}>
      <div className={"loading-screen-content"}>
        <i className={"icon-svg-loading"}>
          <ReactLogo id={"logo-loading"} />
        </i>
        <h1>
          <Trans i18nKey={"components.loading-screen.loading"}>
            Načítám...
          </Trans>
        </h1>
      </div>
    </div>
  );
};
export default withTranslation()(LoadingScreen);
